import "./App.css";

const Contact = () => (
  <>
    <div className="contact-container" id="contact">
      <h1>Contact</h1>
      <p className="contact-email">
        For all inquiries, please email us <a href="mailto:joiacreativeteam@gmail.com">here</a>.
      </p>
    </div>
  </>
);

export default Contact;
